export const credentialsTypesPermission = {
    credentialsTypesCreate: "credentials-types.create",
    credentialsTypesDelete: "credentials-types.delete",
    credentialsTypesUpdate: "credentials-types.update",
    credentialsTypesView: "credentials-types.view"
};
